module.exports = __webpack_public_path__ + "static/img/ground9.d37442cc.png";